import React, { useState, useEffect } from "react";
import "./Css/EmployeeManagement.css";
import { FiTrash2 } from "react-icons/fi";

const employeeFields = [
  { name: "name", label: "Name", type: "text" },
  { name: "employeeCode", label: "Emp ID", type: "text", editable: false },
  { name: "designation", label: "Designation", type: "text" },
  { name: "category", label: "Category", type: "text" },
  { name: "deploymentArea", label: "Deployment Area", type: "text" },
  { name: "responsibility", label: "Responsibility", type: "text" },
  { name: "reportingTo", label: "Reporting To", type: "text" },
  { name: "speakUpReporting", label: "Speak-Up Reporting", type: "text" },
  { name: "mdlzSpoc", label: "MDLZ SPOC", type: "text" },
  { name: "contactNo", label: "Contact No", type: "tel", pattern: "[0-9]{10}" },
];

const emptyEmployee = Object.fromEntries(
  employeeFields.map((f) => [f.name, ""])
);

const user = window.sessionStorage.getItem("user");
console.log(user, "user");

function EmployeeManagement({ onAdd }) {
  const [employees, setEmployees] = useState([]);
  const [editIdx, setEditIdx] = useState(null);
  const [editForm, setEditForm] = useState(emptyEmployee);
  const [searchId, setSearchId] = useState("");

  const baseUrl = "https://mondelezbc.vsmglobaltechnologies.com/api/user";
  // Fetch all employees on load
  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const role = "Employee";
      const res = await fetch(`${baseUrl}/all?role=${role}`);

      const data = await res.json();
      if (res.ok) {
        setEmployees(data.data);
      } else {
        setEmployees([]);
      }
    } catch (err) {
      console.error("Error fetching employees:", err);
    }
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const startEdit = (idx) => {
    setEditIdx(idx);
    setEditForm(employees[idx]);
  };

  const saveEdit = async (e) => {
    e.preventDefault();
    const empCode = editForm.employeeCode;

    try {
      const res = await fetch(`${baseUrl}/${empCode}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(editForm),
      });

      if (res.ok) {
        alert("Employee updated successfully!");
        await fetchEmployees();
        setEditIdx(null);
      } else {
        const err = await res.json();
        alert(err.message || "Failed to update employee");
      }
    } catch (error) {
      console.error("Error updating employee:", error);
    }
  };

  const cancelEdit = () => {
    setEditIdx(null);
    setEditForm(emptyEmployee);
  };

  const deleteEmployee = async (idx) => {
    const empCode = employees[idx].employeeCode;
    const confirmDelete = window.confirm(`Delete employee ${empCode}?`);
    if (!confirmDelete) return;

    try {
      const res = await fetch(`${baseUrl}/${empCode}`, {
        method: "DELETE",
      });

      if (res.ok) {
        alert("Employee deleted successfully!");
        fetchEmployees();
      } else {
        const err = await res.json();
        alert(err.message || "Failed to delete employee");
      }
    } catch (error) {
      console.error("Error deleting employee:", error);
    }
  };

  const filteredEmployees = employees.filter((emp) =>
    emp.employeeCode?.toLowerCase().includes(searchId.toLowerCase())
  );

  return (
    <div className="container">
      <div className="header-row mb-3 d-flex justify-content-between align-items-center">
        <h3>Employee Management</h3>
        <button className="btn btn-success" onClick={onAdd}>
          Add Employee
        </button>
      </div>

      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search by Employee ID"
          value={searchId}
          onChange={(e) => setSearchId(e.target.value)}
        />
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-bordered align-middle">
          <thead className="table-light">
            <tr>
              {employeeFields.map((f) => (
                <th key={f.name}>{f.label}</th>
              ))}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredEmployees.length === 0 ? (
              <tr>
                <td
                  colSpan={employeeFields.length + 1}
                  className="text-center text-muted"
                >
                  No employees found
                </td>
              </tr>
            ) : (
              filteredEmployees.map((emp, idx) =>
                editIdx === idx ? (
                  <tr key={emp.employeeCode} className="table-warning">
                    {employeeFields.map((f) => (
                      <td key={f.name}>
                        {f.editable === false ? (
                          <input
                            {...f}
                            value={editForm[f.name]}
                            readOnly
                            className="form-control-plaintext text-muted"
                          />
                        ) : (
                          <input
                            {...f}
                            value={editForm[f.name]}
                            onChange={handleEditChange}
                            className="form-control"
                          />
                        )}
                      </td>
                    ))}
                    <td>
                      <button
                        className="btn btn-primary btn-sm me-2"
                        onClick={saveEdit}
                      >
                        Save
                      </button>
                      <button
                        className="btn btn-secondary btn-sm"
                        onClick={cancelEdit}
                      >
                        Cancel
                      </button>
                    </td>
                  </tr>
                ) : (
                  <tr key={emp.employeeCode}>
                    {employeeFields.map((f) => (
                      <td key={f.name}>{emp[f.name]}</td>
                    ))}
                    <td className="action-buttons">
                      <button
                        className="btn btn-outline-primary btn-sm me-2"
                        onClick={() => startEdit(idx)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => deleteEmployee(idx)}
                      >
                        <FiTrash2 size={16} />
                      </button>
                    </td>
                  </tr>
                )
              )
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default EmployeeManagement;
